import { runtimeConfig } from '@app/common/config'

export const isTestEnvironment = () => {
  return runtimeConfig.TEST_HEADER
}
